import { Text } from '@yes.technology/react-toolkit'
import { type GanttFooterMilestone } from 'site/Renderer/components/GanttChart/Gantt.utils'

import {
  MilestoneBlock,
  MilestoneTitleLine
} from './GanttCockpitSidebar.styles'

export type GanttCockpitMilestoneListProps = {
  milestones: GanttFooterMilestone[]
}

const GanttCockpitMilestoneList = ({
  milestones
}: GanttCockpitMilestoneListProps) => {
  if (milestones.length === 0) {
    return null
  }

  return (
    <div data-testid='gantt-cockpit-milestone-list'>
      {milestones.map((milestone, index) => (
        <div key={`${milestone.label}-${milestone.date}`}>
          <MilestoneBlock>
            <MilestoneTitleLine>
              <Text variant='content-emphasis-04' as='span'>
                {milestone.label}
              </Text>
            </MilestoneTitleLine>
            {milestone.description ? (
              <Text alignment='justify' variant='content-04'>
                {milestone.description}
              </Text>
            ) : null}
          </MilestoneBlock>
        </div>
      ))}
    </div>
  )
}

export default GanttCockpitMilestoneList
